import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = {
  class: "modal-container-calendar",
  ref: "target"
}
const _hoisted_4 = { class: "modal-body mtop-10" }
const _hoisted_5 = { class: "row w-full" }
const _hoisted_6 = { class: "col-0-8 colend mright-04" }
const _hoisted_7 = { class: "main-m" }
const _hoisted_8 = { class: "row w-full mtop-10" }
const _hoisted_9 = { class: "col-0-8 colend mright-04" }
const _hoisted_10 = { class: "main-m" }
const _hoisted_11 = { class: "row w-full mtop-10" }
const _hoisted_12 = { class: "col-0-8 colend mright-04" }
const _hoisted_13 = { class: "main-m" }
const _hoisted_14 = { class: "row w-full mtop-10" }
const _hoisted_15 = { class: "col-0-8 colend mright-04" }
const _hoisted_16 = { class: "main-m" }
const _hoisted_17 = {
  key: 0,
  class: "row w-full mtop-10"
}
const _hoisted_18 = { class: "col-0-8 colend mright-04" }
const _hoisted_19 = { class: "main-m" }

import { CreateUpdateCommonFinancialGroupRequest, FinancialGroupLightResponse } from "@/apiGenerate/medserver";
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import InputText from 'primevue/inputtext';
import Textarea from 'primevue/textarea';
import ToggleSwitch from 'primevue/toggleswitch';


export default /*@__PURE__*/_defineComponent({
  __name: 'esAddCommonFinancialGroupForm',
  props: {
    isOpen: { type: Boolean },
    header: {},
    currentFinancialGroup: {},
    confirmMethod: { type: Function }
  },
  emits: ["modal-close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { t } = useI18n();

const emits = __emit;

const createUpdateCommonFinancialGroupRequest = ref<CreateUpdateCommonFinancialGroupRequest>({
    code: undefined,
    title: undefined,
    misaNumber: undefined,
    active: true,
    personalInfo: undefined
});

const closeFormModal = () => {
  emits('modal-close');
}

const confirmFormModal = async () => {
  try {
    await props.confirmMethod(createUpdateCommonFinancialGroupRequest.value);
  } catch {
    throw t('error.DEFAULT');
  }
  
}

watch(
  () => props.isOpen,
  () => {
    if (props.isOpen && props.currentFinancialGroup) {
      createUpdateCommonFinancialGroupRequest.value = {
        code: props.currentFinancialGroup.code,
        title: props.currentFinancialGroup.title,
        misaNumber: props.currentFinancialGroup.misaNumber,
        active: props.currentFinancialGroup.active,
        personalInfo: props.currentFinancialGroup.personalInfo
      }
    } else {
      createUpdateCommonFinancialGroupRequest.value = {
        code: undefined,
        title: undefined,
        misaNumber: undefined,
        active: true,
        personalInfo: undefined
      }
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_es_modal_header = _resolveComponent("es-modal-header")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_es_modal_header, { header: _ctx.header }, null, 8, ["header"]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_unref(t)('admin.financialGroup.form.code')), 1),
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                  ])
                ]),
                _createVNode(_unref(InputText), {
                  type: "text",
                  size: "small",
                  modelValue: createUpdateCommonFinancialGroupRequest.value.code,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((createUpdateCommonFinancialGroupRequest.value.code) = $event)),
                  class: "w-full"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, [
                    _createTextVNode(_toDisplayString(_unref(t)('admin.financialGroup.form.title')), 1),
                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                  ])
                ]),
                _createVNode(_unref(InputText), {
                  type: "text",
                  size: "small",
                  modelValue: createUpdateCommonFinancialGroupRequest.value.title,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((createUpdateCommonFinancialGroupRequest.value.title) = $event)),
                  class: "w-full"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, [
                    _createTextVNode(_toDisplayString(_unref(t)('admin.financialGroup.form.misaNumber')), 1),
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                  ])
                ]),
                _createVNode(_unref(InputText), {
                  type: "text",
                  size: "small",
                  modelValue: createUpdateCommonFinancialGroupRequest.value.misaNumber,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((createUpdateCommonFinancialGroupRequest.value.misaNumber) = $event)),
                  class: "w-full"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)('admin.financialGroup.form.personalInfo')), 1)
                ]),
                _createVNode(_unref(Textarea), {
                  modelValue: createUpdateCommonFinancialGroupRequest.value.personalInfo,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((createUpdateCommonFinancialGroupRequest.value.personalInfo) = $event)),
                  class: "w-full",
                  rows: "2",
                  autoResize: ""
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.currentFinancialGroup)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)('admin.financialGroup.form.active')), 1)
                    ]),
                    _createVNode(_unref(ToggleSwitch), {
                      modelValue: createUpdateCommonFinancialGroupRequest.value.active,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (createUpdateCommonFinancialGroupRequest.value.active = $event))
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_es_modal_footer, {
              onModalCancel: closeFormModal,
              confirmModalMethod: () => confirmFormModal()
            }, null, 8, ["confirmModalMethod"])
          ], 512)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})